import React from "react";
import FooterTitleText from "./componet/FooterTitleText/FooterTitleText";
import {
  FooterWrapper,
  FooterDetailBoxWrapper,
  FooterText,
  FooterBlock,
  FooterMobileAppBoxWrapper,
  FooterMobileAppLogoWrapper,
  FooterMobileAppLogo,
  FooterLineAppLogo,
  FooterListLogo,
  FooterSocialButtonWrapper,
  FooterSocialCountryWrapper,
  FooterButton,
  FooterLine,
  FooterLink,
} from "./FooterStyled";
import FooterViewModel from "./FooterViewModel";
import AppStoreApp from "../../../Assets/Image/Footer/AppStoreApp.svg";
import GooglePlayApp from "../../../Assets/Image/Footer/GooglePlayApp.svg";
import LineApp from "../../../Assets/Image/Footer/LineApp.svg";
import ListLogo from "../../../Assets/Image/Footer/ListLogo.svg";
import Arrow from "../../../Assets/Image/Footer/Arrow.svg";
import FooterSocialMedia from "./componet/FooterSocialMedia/FooterSocialMedia";
import FooterCountry from "./componet/FooterCountry/FooterCountry";
import { useMediaQuery } from "@mui/material";

const Footer = () => {
  const { getInTouchWithUsDetail, quickLinks, help } = FooterViewModel();
  const isTablet = useMediaQuery("(min-width:744px)");
  return (
    <FooterWrapper>
      <FooterBlock>
        <FooterTitleText title="GET IN TOUCH WITH US" />
        <FooterDetailBoxWrapper>
          {getInTouchWithUsDetail.map((detail, index) => (
            <div key={index}>
              <FooterText fontColor={"#9EA9B9"}>{detail.title}</FooterText>
              <FooterText>{detail.detail}</FooterText>
              {detail.title === "Monday-Saturday: " ? (
                <div>
                  <FooterText fontColor={"#9EA9B9"}>{detail.title2}</FooterText>
                  <FooterText>{detail.detail2}</FooterText>
                </div>
              ) : null}
            </div>
          ))}
        </FooterDetailBoxWrapper>
      </FooterBlock>
      <FooterBlock>
        <FooterTitleText title="OUR MOBILE APP" />
        <FooterMobileAppBoxWrapper>
          <FooterMobileAppLogoWrapper>
            <a href="https://apps.apple.com/th/app/unicity/id1141128513?l=th" target="_blank" rel="noreferrer">
              <FooterMobileAppLogo src={AppStoreApp} />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.unicity.mobile.fancypants.Unicity"
              target="_blank"
              rel="noreferrer"
            >
              <FooterMobileAppLogo src={GooglePlayApp} />
            </a>
          </FooterMobileAppLogoWrapper>
          <FooterMobileAppLogoWrapper>
            <a href="https://page.line.me/unicity?openQrModal=true" target="_blank" rel="noreferrer">
              <FooterLineAppLogo src={LineApp} />
            </a>
          </FooterMobileAppLogoWrapper>
        </FooterMobileAppBoxWrapper>
      </FooterBlock>
      <FooterBlock>
        <FooterTitleText title="QUICK LINKS" />
        <FooterDetailBoxWrapper gap={"15px"}>
          {quickLinks.map((link, index) => (
            <FooterLink key={index}>
              <FooterListLogo src={ListLogo} />
              {link.title}
            </FooterLink>
          ))}
        </FooterDetailBoxWrapper>
      </FooterBlock>
      <FooterBlock>
        <FooterTitleText title="HELP" />
        <FooterDetailBoxWrapper gap={"15px"}>
          {help.map((link, index) => (
            <FooterLink href={link.link} key={index}>
              <FooterListLogo src={ListLogo} />
              {link.title}
            </FooterLink>
          ))}
        </FooterDetailBoxWrapper>
      </FooterBlock>
      <FooterSocialButtonWrapper>
        {isTablet ? null : <FooterSocialMedia />}
        <FooterButton onClick={() => window.scrollTo(0, 0)}>
          <img src={Arrow} alt="arrow" />
        </FooterButton>
      </FooterSocialButtonWrapper>
      <FooterLine />
      <FooterSocialCountryWrapper>
        {isTablet ? <FooterSocialMedia /> : null}
        <FooterCountry />
      </FooterSocialCountryWrapper>
    </FooterWrapper>
  );
};

export default Footer;
